import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Bullet, Text } from './atoms';

const template = styled.div`
  display: flex;
  align-items: center;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Bullet,
      name: 'Bullet',
      displayValue: ({ }) => '',
      displayState: ({ color }) => ({ color })
    },
    {
      component: Text,
      name: 'Text',
      displayValue: ({ text }) => text,
    },
  ],
})